import React from 'react';

export default function Home() {
    return (
        <div className="container my-5">
            <div className="d-flex" style={{ fontSize: '20px', color: '#7500c0' }}>
                <strong>License Management</strong>
            </div>
            <hr className="divider"></hr>
            <div className='row justify-content-md-center mx-4 my-3'>
                <div className="col col-lg-4 my-3 mx-5">
                    <div className="card rounded-3 shadow-lg" style={{ background: '#7500c0', width: "20rem", transition: 'box-shadow 0.0s' }}>
                        <div className="card-body rounded-3 bg-hover-dark" style={{ color: 'white', boxShadow: '15px 20px 20px rgba(0, 0, 0, 1)', transition: 'background 0.0s', textAlign: 'left', height: '250px' }}>
                            <h5 className="card-title text-start" style={{ fontSize: '20px' }}>Celonis LMS</h5>
                            <p className="card-text text-start" style={{ fontSize: '14px' }}>
                                This portal is designed for requesting Celonis licenses, streamlining the process of approval and provisioning. It also functions as a centralized platform to efficiently manage and track all requests, from initiation through provisioning to closure.
                            </p>
                            <a href="https://bpm.accenture.com/license-management/" target="_blank" rel="noopener noreferrer" className="card-link position-absolute bottom-1" style={{ color: 'white', textDecoration: 'none', transition: 'color 0.3s' }}>
                                <strong className='visit-celonis'>Click here</strong>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col col-lg-4 my-3 mx-5">
                    <div className="card rounded-3 shadow-lg" style={{ background: '#7500c0', width: "20rem", transition: 'box-shadow 0.0s', position: 'relative' }}>
                        <div className="card-body rounded-3 bg-hover-dark" style={{ color: 'white', boxShadow: '15px 20px 20px rgba(0, 0, 0, 1)', transition: 'background 0.0s', textAlign: 'left', height: '250px' }}>
                            <h5 className="card-title text-start" style={{ fontSize: '20px' }}>Signavio LMS</h5>
                            <p className="card-text text-start" style={{ fontSize: '14px' }}>
                                This portal is designed for requesting Signavio licenses, streamlining the approval and provisioning process. It also serves as a unified hub to efficiently manage and track all requests, from request initiation through provisioning to closure.
                            </p>
                            <a href="https://bpm.accenture.com/signavio-license-management/" target="_blank" rel="noopener noreferrer" className="card-link position-absolute bottom-1" style={{ color: 'white', textDecoration: 'none', transition: 'color 0.3s' }}>
                                <strong className='visit-celonis'>Click here</strong>
                            </a>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

// this portal is used to raise requet for celoins licenes. to  get it raised and provisioned. this portal also used to manage and track all the request raised, provisioned or closed